<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="uGgZAvUHI5BjGeJOmal4MvC">
<p class="CHAPTER-SUB"><br/></p>
<p class="CHAPTER-SUB">Author’s Note</p>
<p class="FIRSTPARAGRAPH---Space">This novel is a work of fiction, any resemblance to persons living or dead is purely coincidental; however, the author has taken the liberty of using historical characters, references and places to enhance the reader experience.</p>
<p class="FIRSTPARAGRAPH---Space">References to known and convicted criminals, along with political figures and places have been added to enhance the story and lend realism to the fictional tale contained in this story.</p>
<p class="FIRSTPARAGRAPH---Space">References to police departments or bureaus of investigation, including local, state and federal are a fictional account. This story does not reflect in any way on the organizations mentioned or their level of professionalism. This is a fictional tale as are the characters and events, any resemblance is again purely coincidental. </p>
<p class="FIRSTPARAGRAPH---Space">Any omission or error rests solely with the author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AuthorNote.vue?19bfe116